import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { N1StaticDatumsEdit } from "./edit";
import { N1StaticDataNew } from "./new";
import { N1StaticDatumsTable } from "./table";
export default function N1StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<N1StaticDatumsEdit />} />
      <Route index element={<N1StaticDatumsTable />} />
      <Route path="/new" element={<N1StaticDataNew />} />
    </Routes>
  );
}
